import { AthosFetcher } from '../classes/athos-fetcher'
import { normaliseFacets, normaliseResults } from '../helpers/normalisers'
import { generateAthosProvider } from './provider'
import { isAthosInstockOnly } from '../athos-utils'

export class AthosSearch extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options = {}) {
    const { query, originalQuery, page, resultsPerPage, tag, filters, sort } = options
    if (!query || query === 'null') return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (tag) this.params.set('tag', tag)

    if (sort) this.params.setSort(sort)
    else this.params.clearSort()
    this.params.setFilters(filters instanceof Set ? filters : new Set())

    super.updateParams()
  }
}

export const AthosSearchProvider = generateAthosProvider(AthosSearch, (results) => {
  return {
    ...results,
    facets: normaliseFacets(results?.facets || []),
    results: normaliseResults(results?.results)
  }
})
